import { ReactionType } from '../firebase/firebase.types';
import { TripCard } from '../redux/trip/trip.types';

export const REACTION_TYPES = [
  ReactionType.MUST_GO,
  ReactionType.STAR,
  ReactionType.YES,
  ReactionType.MAYBE,
  ReactionType.NO,
] as const;

export const getReactionEmoji = (reactionType: ReactionType): string => {
  const emojis = {
    [ReactionType.YES]: '👍',
    [ReactionType.MAYBE]: '🤔',
    [ReactionType.NO]: '👎',
    [ReactionType.STAR]: '🤩',
    [ReactionType.MUST_GO]: '💯',
  };
  return emojis[reactionType];
};

export const getReactionCounts = (card: TripCard) => {
  const counts = {
    [ReactionType.YES]: 0,
    [ReactionType.MAYBE]: 0,
    [ReactionType.NO]: 0,
    [ReactionType.STAR]: 0,
    [ReactionType.MUST_GO]: 0,
  };

  // Count all reactions
  const reactions = Object.values(card?.reactions || {});
  reactions.forEach((reaction) => {
    if (reaction?.type !== undefined) {
      counts[reaction.type] += 1;
    }
  });

  return counts;
};
